import { ToggleButton,Tooltip } from '@mui/material';
import React, { ReactNode } from 'react';


export interface IIconToggleProps {
  iconOn:          ReactNode,
  iconOff:         ReactNode,
  selected:        boolean,
  tooltipIconOn?:  string,
  tooltipIconOff?: string,
  size?:           "small" | "medium" | "large",
  onChange(value: boolean): void,
}

export const IconToggle = (props: IIconToggleProps): JSX.Element => {
  const { iconOn, iconOff, size, selected, tooltipIconOn, tooltipIconOff, onChange } = props;

  const icon = React.useMemo(() => 
    selected ? iconOn : iconOff
  , [iconOn, iconOff, selected]);
  
  return (
    <Tooltip placement='bottom' title={selected ? tooltipIconOn : tooltipIconOff}>
      <ToggleButton
        size     = {size || "small"}
        value    = "check"
        selected = {selected}
        onChange = {() => onChange(!selected)}
      >
        {icon}
      </ToggleButton>
    </Tooltip>
  );
};